module.exports = __webpack_public_path__ + "img/241-st-vincent-and-the-grenadines.2a9b1e94.svg";